import { format } from "date-fns";

export default {
	name: "KTimeAgo",

	props: {
		format: {
			default: "EEEE, MMMM do, yyyy, h:mm:ss a"
		},

		tag: {
			default: "div",
			type: String
		},

		// May be useful if your formatting only shows the day (and not the time) for example,
		// no need to run the interval updater every second in that case
		updateInterval: {
			default: 1000,
			type: Number
		}
	},

	data: () => ( {
		interval: null,
		now: Date.now()
	} ),

	created() {
		this.interval = setInterval( () => {
			this.now = Date.now();
		}, this.updateInterval );
	},

	destroyed() {
		clearInterval( this.interval );
	},

	render() {
		return <this.tag>{format( this.now, this.format )}</this.tag>;
	}
};
